import api from "./apiAgent";

export const getConfig = () => {
  return api.post("config");
};

export const getPlantConfig = (code: string = ""): Promise<any> => {
  return api.get(`plantlocations/${code}`);
};
